@if (status === 1) {
  <div class="zwi-main-content">
    <zwi-widget>
      <div>Loading</div>
    </zwi-widget>
  </div>
} @else {
  @if (searchLoaded()) {
    @if (sermons.length > 0) {
      <zwi-sermon-list [bookmarkable]="authService.hasSession()" [sermons]="sermons" (starChange)="favoriteChange($event)"></zwi-sermon-list>
    } @else {
      <zwi-widget>No results containing your search terms were found.</zwi-widget>
    }
  } @else {
    <zwi-widget>Search for sermons</zwi-widget>
  }
}
